<template>
  <div v-if="!isLoading">
    <TaskView type="editor" @onSave="onSave">
      <template v-if="isDiagram">
        <DiagramView
          ref="diagramView"
          :show-list="true"
          :show-toolbar="true"
          :tool="'editor'"
          :read-only="!canMutateTask"
        />
      </template>
      <template v-else-if="isInstruction">
        <InstructionView
          ref="instructionView"
          :task="currentTask"
          viewType="publisher"
          :read-only="!canMutateTask"
        />
      </template>
    </TaskView>
  </div>
  <div v-else>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import DiagramView from '../../../components/Shared/DiagramView';
import InstructionView from '../../../components/Shared/InstructionView';
import TaskView from '../../../components/Shared/TaskView';
import TaskViewMixin from '../../../mixins/Shared/TaskViewMixin';

export default {
  components: { DiagramView, InstructionView, TaskView },
  mixins: [TaskViewMixin],
  computed: {
    // `isInstruction` computed property is inherited from TaskViewMixin
    // `isDiagram` computed property is inherited from TaskViewMixin
    // `currentTask` computed property is inherited from TaskViewMixin
  },
  methods: {
    // `onSave` method is inherited from TaskViewMixin
  },
};
</script>
